<template>
  <Modal extra-class="dea-modal__name dea-modal--no-footer" :visible="visible" @modal-close="$emit('modal-close')">
    <template v-if="user.parent_id" #title>
      Modifica il {{ nameType === "firstname" ? "nome" : "cognome" }} di {{ user.firstname }}
      {{ user.lastname }}</template
    >
    <template v-else #title> Modifica il tuo {{ nameType === "firstname" ? "nome" : "cognome" }} </template>
    <template #content>
      <div class="dea-heading--medium-xxs dea-modal__name-label">
        {{ nameType === "firstname" ? "Nome" : "Cognome" }}
      </div>
      <input v-model="name" class="dea-modal__name-input" type="text" />
      <Buttons class="dea-button--large" :disabled="!name" @click="updateName()">Salva modifiche</Buttons>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";

export default {
  name: "NameModal",
  components: { Buttons, Modal },
  props: {
    nameType: {
      type: String,
      default: "firstname",
    },
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "",
    };
  },
  mounted() {
    this.name = this.user[this.nameType];
  },
  methods: {
    updateName() {
      this.$emit("user-update", { [this.nameType]: this.name });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$input-wrapper-width: 330px;
$input-height: 40px;

.dea-modal {
  &__name-label {
    margin-bottom: $space-x-small;
    text-transform: uppercase;
  }

  &__name-input {
    height: $input-height;
    margin-bottom: $space-base;
    width: $input-wrapper-width;
  }
}
</style>
